// React&NextJS
import { useCallback, useEffect, useState } from 'react'
// 3rd party libraries
import { connectSearchBox } from 'react-instantsearch-dom'
// Styles
import s from './Search.module.scss'
// Components
import { Button } from '../../core/button/Button'
import { Icon } from '../../core/icon/Icon'
import Select from '../../core/select/Select'
import { usePlausible } from 'next-plausible'

const CustomSearchBox = ({
    refine,
    filter,
    setFilter,
    setSearchState,
    options,
    query,
    isSearchStalled,
}) => {
    const handleUserKeyPress = useCallback((event) => {
        const { key } = event
        if (key === 'Enter') {
            document.getElementById('submit-btn').click()
        }
    }, [])
    const [localQuery, setLocalQuery] = useState('')
    const plausible = usePlausible()

    // Ekki eyða!. Þetta er ef við viljum að það sé hægt að searchOnType
    // Leita á type
    // useEffect(() => {
    //     if (window.innerWidth >= 800) {
    //         refine(query)
    //     }
    // }, [query])

    // Leita á ári on click
    // useEffect(() => {
    //     submit(refine)
    // }, [filter])

    useEffect(() => {
        window.addEventListener('keydown', handleUserKeyPress)

        return () => {
            window.removeEventListener('keydown', handleUserKeyPress)
        }
    }, [])

    useEffect(() => {
        if (query?.name) {
            refine(query.name)
            setLocalQuery(query.name)
        }
    }, [query?.name])

    useEffect(() => {
        setSearchState((prev) => {
            return {
                ...prev,
                isSearchStalled: isSearchStalled,
            }
        })
    }, [isSearchStalled])

    function change(e: any) {
        setFilter(e.value)
    }

    return (
        <>
            <div className={s.name}>
                <Icon variant="search" />
                <input
                    type="text"
                    id="search-input"
                    placeholder="Hvern viltu finna?"
                    className={s.name_input}
                    value={localQuery}
                    onChange={(e) => setLocalQuery(e.target.value)}
                />
            </div>
            <span />

            <Select
                year
                onChange={(e: any) => change(e)}
                className={s.select}
                options={options}
                filter={filter}
            />

            {/* filter data from algolia by year */}
            <Button
                id="submit-btn"
                className={s.submit}
                onClick={() => {
                    setSearchState({
                        query: localQuery,
                        filter: filter,
                        isLoading: false,
                    })
                    plausible('memories-leita-button')
                    refine(localQuery)
                }}
            >
                Leita
            </Button>
        </>
    )
}

export default connectSearchBox(CustomSearchBox)
